import React from "react";
import {
  Grid,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Button,
} from "@material-ui/core";
import styled from "styled-components";
import DatetimeCriteriaConfig from "./DatetimeCriteriaConfig";

const todayDate = new Date();
const Options = [
  { name: Ext.Date.format(todayDate, "M j, Y"), val: "M j, Y" },
  { name: Ext.Date.format(todayDate, "n/j/Y"), val: "n/j/Y" },
  { name: Ext.Date.format(todayDate, "Y/n/j"), val: "Y/n/j" },
  { name: Ext.Date.format(todayDate, "D, M j"), val: "D, M j" },
];

function DateColumnConfig({
  values,
  handleChange,
  setFieldValue,
  valuesPath = "",
  isOnlyFormattingConfig,
  store,
}) {
  const [criteriaAnchorEl, setCriteriaAnchorEl] = React.useState(null);

  React.useEffect(() => {
    if (values.options.format) {
      return;
    }
    setFieldValue(`${valuesPath}options.format`, "M j, Y");
  }, [setFieldValue, values.options.format, valuesPath]);

  const hasCriteria = !!values.options.datetime_criteria;

  return (
    <React.Fragment>
      <Grid item xs={12}>
        <Select
          name={`${valuesPath}options.format`}
          value={values.options.format ?? ""}
          onChange={handleChange}
          variant="outlined"
          style={{ width: 200 }}
        >
          {Options.map((option) => (
            <MenuItem key={option.val} value={option.val}>
              {option.name}
            </MenuItem>
          ))}
        </Select>
      </Grid>
      {!isOnlyFormattingConfig && (
        <>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  color="primary"
                  name={`${valuesPath}options.default_current_time`}
                  checked={values.options.default_current_time ?? ""}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setFieldValue(
                        `${valuesPath}options.allow_free_text`,
                        true
                      );
                    }
                    handleChange(e);
                  }}
                />
              }
              label={"Default as Current Date"}
            />
          </Grid>
          {values.options.default_current_time && (
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    color="primary"
                    name={`${valuesPath}options.allow_free_text`}
                    checked={values.options.allow_free_text || false}
                    onChange={handleChange}
                  />
                }
                label={"Allow user to change Date"}
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <CriteriaButton
              variant="outlined"
              size="small"
              $active={hasCriteria}
              onClick={(e) => setCriteriaAnchorEl(e.currentTarget)}
            >
              Date Criteria
              {hasCriteria && <ActiveDot />}
            </CriteriaButton>
          </Grid>
        </>
      )}

      <DatetimeCriteriaConfig
        anchorEl={criteriaAnchorEl}
        onClose={() => setCriteriaAnchorEl(null)}
        values={values}
        setFieldValue={setFieldValue}
        valuesPath={valuesPath}
        columnType="date"
        store={store}
      />
    </React.Fragment>
  );
}

const CriteriaButton = styled(Button)`
  text-transform: none !important;
  font-size: 12px !important;
  border-color: ${({ $active }) =>
    $active ? "#1976d2 !important" : "rgba(0,0,0,0.23) !important"};
  color: ${({ $active }) =>
    $active ? "#1976d2 !important" : "rgba(0,0,0,0.6) !important"};
  position: relative !important;
`;

const ActiveDot = styled.span`
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #1976d2;
  margin-left: 6px;
  vertical-align: middle;
`;

export default DateColumnConfig;
